import { createRouter, createWebHistory } from 'vue-router'
import routes from './routes' // 导入数组

const router = createRouter({
  history: createWebHistory(),
  routes // 使用导入的数组
})

export default router